import apiService from "./apiService";


export const searchCategory = (query) => {
  return apiService.get(URIS.categories, {params: {name: query}});
};

export const getCategory = (categoryId) => {
  return apiService.get(URIS_D('category', categoryId));
};

const URIS_D = (url, param1) => {
  return {
    category: `${URIS.categories}/${param1}`
  }[url];
};

const URIS = {
  categories: '/v1/categories'
};
